import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { MenuItem } from '@material-ui/core';

import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';

import SelectTextField from '../../../../../../Common/UI/SelectTextField';

function MultiSelectRule(props) {
    const { tree, field } = props;
    const classes = useStyles();
    function handleChange (event) {
        const { tree, onChange } = props;
        const newTree = { ...tree };
        newTree.properties = {
            ...newTree.properties,
            [event.target.name]: event.target.value
        };
        const operator = newTree.properties?.operator;
        const values = newTree.properties?.values;
        if(operator === "==" && (values?.length > 0)) newTree['isValid'] = true;
        if(operator === "==" && (values?.length === 0)) newTree['isValid'] = false;
        if(operator === "!=" && (values?.length > 0)) newTree['isValid'] = true;
        if(operator === "!=" && (values?.length === 0)) newTree["isValid"] = false;
        onChange(newTree);
    }

    function renderSelected (selected) {
        const { field } = props;
        if (selected.length === 0) { 
            return <div style={{ color: '#a9a9a9' }}>{field.settings.listPlaceholder || ''}</div>; 
        } else {
            return field.settings.listOptions
                .filter(el => selected.includes(el.value))
                .map(el => el.label || el.value).join(' or '); 
        }
    }
    
    return (
        <>
            <SelectTextField
                name="operator"
                onChange={handleChange}
                value={tree.properties.operator || ''}
                placeholder="Operator"
                size="small"
            >
                <MenuItem value="==">{'Equals'}</MenuItem>
                <MenuItem value="!=">{'Not Equals'}</MenuItem>
            </SelectTextField>
            <SelectTextField
                name="values"
                value={tree.properties.values || []}
                onChange={handleChange}
                multiple
                SelectProps={{
                    displayEmpty: true,
                    multiple: true,
                    renderValue: renderSelected
                }}
                size="small"
            >
                { field.settings.listOptions.map(el => <MenuItem key={el.value} value={el.value}
                    classes={{
                    root: classes.menuItem
                    }}
                >{el.label || el.value}
                    {
                    tree?.properties?.values?.filter(e=>e === el.value)?.length > 0 ? <CheckBox color="secondary" />:<CheckBoxOutlineBlank />
                }
                </MenuItem>) }
            </SelectTextField>
        </>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        '&> *:not(:last-child)': {
            marginRight: 10
        },
        '&> div': {
            flexGrow: 1
        }
    },
    any: {
        color: '#a9a9a9'
    },
    clear: {
        height: 36
    },
    menuItem:{
        display: "flex",
        justifyContent: "space-between"
    },
}));
MultiSelectRule.propTypes = {
    tree: PropTypes.object.isRequired,
    field: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};


export default MultiSelectRule;